<div class="client-numbers-form">
  <label *ngIf="doClientNumbersExist" class="form-input-wrapper">
    <span class="form-input-label">Primary Fax number:</span>

    <app-select
      [items]="clientNumberOptions"
      [activeItem]="primaryClientNumber"
      [placeholder]="'Select number'"
      [customClass]="'select_l'"
      (selectChange)="selectNumber.emit($event)"
    ></app-select>
  </label>

  <div *ngIf="doClientNumbersExist" class="client-numbers-form-numbers-list">
    <h3 class="client-numbers-form-numbers-list__title">All Assigned Fax Numbers:</h3>

    <p *ngFor="let clientNumber of clientNumbers" class="client-numbers-form-numbers-list__item">
      {{ clientNumber.number }}
    </p>
  </div>

  <button (click)="buyClick.emit()" class="btn_primary btn_lg">Buy additional fax number</button>
</div>
